<template>
  <div>
    <component v-bind:is="currentView"></component>
  </div>


</template>


<script>

  export default {
    components:{
      'mysihat': () => import('./Mysihat/Senarai'),
      // 'kkm': () => import('./KKM'),
      'program': () => import('./Program/Senarai'),
    },
    name: 'App',
    data() {
      return {
        currentView: 'mysihat'
      }
    },
    watch: {

      '$route.params.program'(baru, lama) {
        this.initiate();
      }

    },
    created() {
      this.initiate();
    },
    methods: {
      initiate(){

        if(this.$store.state.kumpulan == 'mysihat'){
          this.currentView = 'mysihat';
        }
        else if(this.$store.state.kumpulan == 'kkm'){
          this.currentView = 'mysihat';
        }
        else if(this.$store.state.kumpulan == 'program'){
          this.currentView = 'program';
        }

        if(this.$store.state.kumpulan == 'mysihat' || this.$store.state.kumpulan == 'kkm'){
          if(this.$store.state.program.id !== undefined){
            this.currentView = 'program';
          }
        }


      }

    },
    mounted: function () {


    },
  }


</script>





// WEBPACK FOOTER //
// src/components/Pengguna/Index.vue